export const Table = {
  align: "enum(left,right,center)",
  border: "string",
  cellpadding: "integer",
  cellspacing: "integer",
  "container-background-color": "color",
  color: "color",
  "font-family": "string",
  "font-size": "unit(px)",
  "font-weight": "string",
  "line-height": "unit(px,%,)",
  "padding-bottom": "unit(px,%)",
  "padding-left": "unit(px,%)",
  "padding-right": "unit(px,%)",
  "padding-top": "unit(px,%)",
  padding: "unit(px,%){1,4}",
  role: "enum(none,presentation)",
  "table-layout": "enum(auto,fixed,initial,inherit)",
  "vertical-align": "enum(top,bottom,middle)",
  width: "unit(px,%)",
};
